"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroImagePreview = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var HeroImagePreview = function HeroImagePreview(props) {
  var src = props.src,
      dimentionLabel = props.dimentionLabel;
  return (0, _preact.h)("div", {
    className: "hero-image-wrapper"
  }, (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)(src)
  }), (0, _preact.h)("a", {
    target: "_blank",
    rel: "noreferrer",
    href: (0, _absoluteUrlRuntime.resolveUrl)(src),
    className: "component-uploader__image-details"
  }, dimentionLabel, " ", (0, _preact.h)("i", {
    className: "icon icon-external"
  })));
};

exports.HeroImagePreview = HeroImagePreview;